import React, { useEffect, useState } from 'react';
import { Modal, Typography, Table, Tag, Statistic, Row, Col, message, Space } from 'antd';
import axios from 'axios';
import { formatCurrency } from '../utils/currency';

const { Text } = Typography;

const SupplierInvoiceDetails = ({ visible, invoiceId, onCancel }) => {
    const [loading, setLoading] = useState(false);
    const [details, setDetails] = useState(null);

    useEffect(() => {
        if (visible && invoiceId) {
            fetchDetails();
        }
    }, [visible, invoiceId]);

    const fetchDetails = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const res = await axios.get(`/api/purchase/invoices/${invoiceId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setDetails(res.data);
        } catch (error) {
            console.error(error);
            message.error('Failed to load supplier invoice details');
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        { title: 'Item', dataIndex: 'libelle', key: 'libelle', render: (t, r) => t || r.description },
        { title: 'Qty', dataIndex: 'qty', key: 'qty' },
        { title: 'U.P.', dataIndex: 'subprice', key: 'subprice', render: val => formatCurrency(val) },
        { title: 'VAT %', dataIndex: 'tva_tx', key: 'tva_tx', render: val => `${parseFloat(val)}%` },
        { title: 'Total', dataIndex: 'total_ttc', key: 'total_ttc', render: val => formatCurrency(val) }
    ];

    if (!details && !loading) return null;

    const isDraft = details?.status === '0' || details?.statut === '0';
    const isValidated = details?.status === '1' || details?.statut === '1';
    const isPaid = details?.status === '2' || details?.statut === '2';

    return (
        <Modal
            title={
                <Space>
                    <Text>Supplier Invoice {details?.ref}</Text>
                    {isDraft && <Tag>Draft</Tag>}
                    {isValidated && <Tag color="blue">Validated</Tag>}
                    {isPaid && <Tag color="success">Paid</Tag>}
                </Space>
            }
            open={visible}
            onCancel={onCancel}
            footer={null}
            width={800}
            destroyOnClose
        >
            {details && (
                <div style={{ marginBottom: 20 }}>
                    <Row gutter={16}>
                        <Col span={8}>
                            <Statistic title="Total (TTC)" value={details.total_ttc} precision={3} suffix="JOD" />
                        </Col>
                        <Col span={8}>
                            <Statistic title="Supplier" value={details.socname} valueStyle={{ fontSize: '16px' }} />
                        </Col>
                        <Col span={8} style={{ textAlign: 'right' }}>
                            <Text type="secondary">Date: {new Date(details.date * 1000).toLocaleDateString()}</Text>
                        </Col>
                    </Row>
                </div>
            )}

            <Table
                dataSource={details?.lines || []}
                columns={columns}
                rowKey="id"
                pagination={false}
                size="small"
                loading={loading}
                bordered
            />
        </Modal>
    );
};

export default SupplierInvoiceDetails;
